<div fxLayout="row" fxLayoutGap="12px" [style.margin-top]="'12px'" *ngIf="role == 'Mandoob'">


    &nbsp;
    &nbsp;
    <mat-card style=" width: 95%;">

        &nbsp;
        <span>
            الرصيد المتوفر : {{ballance}}
        </span>

    </mat-card>
</div>